<template>
  <div class="DMessage inner_center">
    <h1 class="headline">一起来看看20W+用户的一致好评</h1>

    <div class="message-box">

      <div
          v-swiper:mySwiper7="swiperOption7"
          class="swiper swiper7"
          v-if="messageList.slice(0,7).length"
      >
        <div
           class="message-list swiper-wrapper swiper-wrapper1"
        >
          <div
              v-for="vo in messageList.slice(0,7)"
              class="message-item swiper-slide"
          >
            <i class="icon_avatar"
              :class="'icon_'+vo.imgIdx"
            />
            <div class="desc overflow-more">{{ vo.label }}</div>
          </div>
        </div>
      </div>

      <div
          v-swiper:mySwiper8="swiperOption8"
          v-if="messageList.slice(7,14).length"
          class="swiper swiper8">
        <div
            class="message-list message-list2 swiper-wrapper swiper-wrapper2"
        >
          <div
              v-for="vo in messageList.slice(7,14)"
              class="message-item swiper-slide"
          >
            <i class="icon_avatar"
               :class="'icon_'+vo.imgIdx"
            />
            <div class="desc overflow-more">{{ vo.label }}</div>
          </div>
        </div>
      </div>

      <div
          v-swiper:mySwiper9="swiperOption9"
          v-if="messageList.slice(14).length"
          class="swiper swiper9">
        <div
            class="message-list swiper-wrapper swiper-wrapper3"
        >
          <div
              v-for="vo in messageList.slice(14)"
              class="message-item swiper-slide"
          >
            <i class="icon_avatar"
               :class="'icon_'+vo.imgIdx"
            />
            <div class="desc overflow-more">{{ vo.label }}</div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {THREE_D} from '@/constant/3d/3D'

export default {
  name: "DMessage",
  data() {
    return {
      THREE_D,
      messageList:[],
      swiperOption7: {
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        slidesPerView: 2.78, // 设置slider容器能够同时显示的slides数量(carousel模式)
        slidesPerGroup: 1, // 在carousel mode下定义slides的数量多少为一组
        loop: true, // 设置为true 则开启loop(无限循环)模式
        // freeMode: true, //【关键】设置为true则变为free模式
        speed: 9000, //【关键】匀速时间
        centeredSlides: true,
        autoplay: { // 自动播放
          delay: 1, //【关键】自动切换的时间间隔，单位ms
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换。
          stopOnlastSlide: false,
          disableOninteraction: true
        },
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        allowTouchMove: false
      },
      swiperOption8: {
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        slidesPerView: 2.78, // 设置slider容器能够同时显示的slides数量(carousel模式)
        slidesPerGroup: 1, // 在carousel mode下定义slides的数量多少为一组
        loop: true, // 设置为true 则开启loop(无限循环)模式
        // freeMode: true, //【关键】设置为true则变为free模式
        speed: 9000, //【关键】匀速时间
        centeredSlides: true,
        autoplay: { // 自动播放
          delay: 1, //【关键】自动切换的时间间隔，单位ms
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换。
          stopOnlastSlide: false,
          disableOninteraction: true
        },
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        allowTouchMove: false,
        slidesOffsetBefore: 48,
      },
      swiperOption9: {
        observeParents: true,//修改swiper的父元素时，自动初始化swiper
        slidesPerView: 2.78, // 设置slider容器能够同时显示的slides数量(carousel模式)
        slidesPerGroup: 1, // 在carousel mode下定义slides的数量多少为一组
        loop: true, // 设置为true 则开启loop(无限循环)模式
        // freeMode: true, //【关键】设置为true则变为free模式
        speed: 9000, //【关键】匀速时间
        centeredSlides: true,
        autoplay: { // 自动播放
          delay: 1, //【关键】自动切换的时间间隔，单位ms
          pauseOnMouseEnter: true, //鼠标置于swiper时暂停自动切换，鼠标离开时恢复自动切换。
          stopOnlastSlide: false,
          disableOninteraction: true
        },
        observer:true,//修改swiper自己或子元素时，自动初始化swiper
        allowTouchMove: false
      },
    }
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper7.swiper//组件实例
    }
  },
  mounted() {
    let list = THREE_D.MESSAGE.LIST.slice();

    let messageList = []
    for (let i = 0; i < list.length; i++) {
      messageList.push({
        label: list[i],
        imgIdx: this.randomRange(1,12)
      })
    }
    this.messageList = messageList
  },
  methods:{
    randomRange(min, max) { // min最小值，max最大值
      return Math.floor(Math.random() * (max - min)) + min;

    }
  }
}
</script>

<style lang="scss" scoped>
.DMessage {
  overflow: hidden;

  .headline {
    font-size: 44px;
    font-weight: bold;
    color: #21222E;
    line-height: 59px;
    letter-spacing: 1px;
    text-align: center;
    margin: 0px 0 0px;
  }

  .message-box {
    position: relative;
    padding-top: 64px;

    .message-list {
      margin-bottom: 24px;
      display: flex;

      .message-item {
        width: 540px !important;
        height: 86px !important;
        @include BgImage(540px, 86px, '3d/message/message-bg.png');
        flex-shrink: 0;
        display: flex;
        //align-items: center;
        padding: 10px 20px 0 16px;
        box-sizing: border-box;

        .icon_avatar {
          display: inline-flex;
          width: 48px;
          height: 48px;
          border-radius: 50%;
          background: pink;
          margin-right: 16px;
          flex-shrink: 0;
        }

        @for $i from 1 to 12 {
          .icon_#{$i} {
            //width: #{$i}px !important;
            @include BgImage(48px,48px,'3d/message/icon_#{$i}.png');
          }
        }

        .desc {
          width: 440px;
          height: 48px;
          font-size: 14px;
          color: #424866;
          line-height: 24px;
        }
      }

      &.message-list2{
        //margin-left: 48px;
      }
    }


    &:after {
      content: "";
      display: inline-block;
      width: 240px;
      height: 483px;
      background: linear-gradient(360deg, #F5F6FA 0%, #FCFCFD 100%);
      filter: blur(50px);
      @include Position(1, 2, -120px, 0);
      z-index: 99;
    }

    &:before {
      content: "";
      display: inline-block;
      width: 240px;
      height: 483px;
      background: linear-gradient(360deg, #F5F6FA 0%, #FCFCFD 100%);
      filter: blur(50px);
      @include Position(1, 5, -120px, 0);
      z-index: 99;
    }



  }

  ::v-deep .swiper-wrapper{
    transition-timing-function: linear !important;
  }
}

</style>
